<template>
  <div>
    <MasterLayout>
      <div class="quickfuel_first_row">
        <div
          class="quickfuel_first_row_right_section co_dealer_details"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="row align-items-center quick_fuel">
            <div class="col-md-6 col-lg-12 text-center">
              <img src="@/assets/img/email.png" class="mr-5" width="50px" />
              <span class="quick_fuel_banner_header"
                >{{ $t("text.mailRecipient.title") }} ({{ branchName }})</span
              >
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3">
        <div class="row add_driver_row">
          <div class="col-md-12 col-lg-5 add-driver_form_row">
            <div class="driver_form_row">
              <div class="text-center">
                <img src="@/assets/img/email (1).svg" />
              </div>
              <h3 class="add_driver_header text-center py-3">
                {{ $t("text.mailRecipient.addRecipient") }} ({{ branchName }})
              </h3>
              <div class="Add_driver_form">
                <div class="form_input_section mt-5">
                  <div class="input__div" ref="email_input_div">
                    <div class="placeholder_div">
                      <img
                        src="@/assets/img/email.png"
                        width="50%"
                        class="input_placeholder_icon"
                      />
                    </div>
                    <div class="input_field_section">
                      <input
                        type="email"
                        :placeholder="$t('text.mailRecipient.emailPlaceholder')"
                        v-model="email"
                        @blur="captureFormEvents($event)"
                      />
                    </div>
                  </div>
                </div>
                <div ref="email_error_message"></div>
                <div class="form_input_section mt-5">
                  <div class="input__div" ref="phone_input_div">
                    <div class="placeholder_div">
                      <img
                        src="@/assets/img/phone.png"
                        width="50%"
                        class="input_placeholder_icon"
                      />
                    </div>
                    <div class="input_field_section">
                      <input
                        type="phone"
                        :placeholder="$t('text.mailRecipient.phonePlaceholder')"
                        v-model="phone"
                        @blur="captureFormEvents($event)"
                      />
                    </div>
                  </div>
                </div>
                <div class="text-center mt-4">
                  <button
                    class="add_quick_fuel_btn"
                    @click="addMailReceipient($event)"
                    :disabled="isButtonDisabled ? true : null"
                    :style="[
                      isButtonDisabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' },
                    ]"
                  >
                    {{ $t("text.mailRecipient.add") }} <span></span>
                  </button>
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    class="ml-3 loader"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-7">
            <div class="drivers_list mr-3">
              <ejs-grid
                v-show="!showLoader"
                ref="dataGrid"
                :dataBound="dataBound"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="toolbarClick"
                :locale="usedLang"
              >
                <e-columns>
                  <e-column width="40" field="index" headerText="#"></e-column>
                  <e-column
                    field="email"
                    :headerText="$t('text.mailRecipient.email')"
                    width="150"
                  ></e-column>
                  <e-column
                    field="phoneNumber"
                    width="300"
                    :headerText="$t('text.mailRecipient.phone')"
                  ></e-column>
                  <e-column
                    width="300"
                    :template="deleButtonTemplate"
                    :headerText="$t('text.actionButtons.title')"
                  ></e-column>
                </e-columns>
              </ejs-grid>
              <TableLoader :showLoader="showLoader" />
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/profile_banner.png";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Mail Receipient :: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      branchId: this.$route.query.id,
      branchName: "",
      backgroundUrl,
      isButtonDisabled: false,
      formIsValid: false,
      showLoader: false,
      email: null,
      phone: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      deleButtonTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<button class="delete_btn" v-on:click="removeMailRecipient(data.id)">{{data.deleteButton}}</button>',
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              removeMailRecipient: function (id) {
                this.$eventHub.$emit("_removeMailRecipient", id);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("_removeMailRecipient", (id) => {
      this.deleteMailRecipient(id);
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("_removeMailRecipient");
  },

  mounted() {
    this.branchId = this.$route.query.id;
    let branches = JSON.parse(localStorage.getItem("branches"));
    this.branchName = branches.filter(
      (branch) => branch.id == this.branchId
    )[0].name;
    this.getMailRecipients();
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    dataBound() {
      this.$refs.dataGrid.autoFitColumns(["email"]);
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    deleteMailRecipient(id) {
      var resp = confirm(this.$t("text.mailRecipient.confirmDelete"));
      if (resp) {
        let data = {
          id: id,
        };
        this.axios
          .post(
            `${configObject.apiBaseUrl}/Branch/RemoveMailRecipient`,
            data,
            configObject.authConfig()
          )
          .then(() => {
            this.$toast.open({
              message: this.$t("text.mailRecipient.successfullyRemoved"),
              type: "success",
              duration: 5000,
            });
            this.getMailRecipients();
          })
          .catch((error) => {
            this.$toast.open({
              message: error.response.data.message,
              type: "error",
              duration: 5000,
            });
          });
      }
    },
    getMailRecipients() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/MailRecipients/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          response.data.forEach((recipient) => {
            recipient.index = ++index;
            recipient.deleteButton = this.$t("text.actionButtons.delete");
          });
          this.showLoader = false;

          grid.ej2Instances.setProperties({ dataSource: response.data });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    addMailReceipient($event) {
      $event.preventDefault();
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.validEmail(this.email)) {
        this.$toast.open({
          message: this.$t("text.errors.invalidEmail"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (this.phone && (this.phone.length < 10 || this.phone.length > 13)) {
        this.$toast.open({
          message: this.$t("text.errors.shortPhoneNumber"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      let data = {
        phoneNumber: this.phone,
        email: this.email,
        branchId: this.branchId,
      };
      this.isButtonDisabled = true;
      $(".loader").show();
      let _this = this;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Branch/CreateMailRecipient`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.getMailRecipients();
          this.$toast.open({
            message: this.$t("text.mailRecipient.successfullyAdded"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          $(".checked_icon").show();
          this.isButtonDisabled = false;
          data = null;
          this.pin = null;
          this.confirmPin = null;
          this.QuickFuelMethod = null;
          this.magneticCardStripe = null;
          this.phoneNumber = null;
          this.amount = null;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },

    captureFormEvents($event) {
      if (
        $event.target.placeholder ===
        this.$t("text.mailRecipient.emailPlaceholder")
      ) {
        if ($event.target.value === "") {
          this.$refs.email_error_message.style.display = "block";
          this.$refs.email_error_message.innerHTML = this.$t(
            "text.errors.emailMissing"
          );
          this.$refs.email_input_div.style.border = "1px solid red";
          this.$refs.email_error_message.style.color = "red";
          this.formIsValid = false;
        } else {
          if (this.validEmail($event.target.value)) {
            this.$refs.email_error_message.style.display = "none";
            this.$refs.email_error_message.innerHTML = "";
            this.$refs.email_input_div.style.border =
              "1px solid rgb(75, 44, 114)";
            this.formIsValid = true;
          } else {
            this.$refs.email_error_message.style.color = "red";
            this.$refs.email_error_message.innerHTML = "Invalid Email format";
            this.$refs.email_input_div.style.border = "1px solid red";
            this.formIsValid = false;
          }
        }
      }
    },
  },
};
</script>
